import {ParameterBase} from '~/app/core/reports/models/ParameterBase';

export class InputField extends ParameterBase<string> {
  controlType = 'textbox';
}
